<template>
  <div class="welcome-container">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>

<script>
import WelcomeDefault from './Welcome_Default.vue'
import WelcomeHNACS from './Welcome_HNACS.vue'
import WelcomeHeNan from './Welcome_HeNan.vue'
import WelcomeHaiNan from './Welcome_HaiNan.vue'
import WelcomePuYang from './Welcome_PuYang.vue'
export default {
  name: 'Welcome',
  components: {
    WelcomeDefault,
    WelcomeHNACS,
    WelcomeHeNan,
    WelcomeHaiNan,
    WelcomePuYang
  },
  data () {
    return {
      layout: '',
      ready: false
    }
  },
  mounted () {
    window.localStorage.removeItem('view-mode')
    let queryRegion = this.$common.searchQueryString('region')
    if (this.$route.params.region === 'henan') {
      this.layout = 'WelcomeHeNan'
      this.ready = true
    } else if (this.$route.params.region === 'puyang' || this.$route.query.region === 'puyang' || queryRegion === 'puyang') {
      window.localStorage.setItem('view-mode', 'puyang')
      this.layout = 'WelcomePuYang'
      this.ready = true
    } else {
      // this.$router.replace('/welcome/henan')
      if (this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']) {
        this.layout = `Welcome${this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']}`
        this.ready = true
      } else {
        this.layout = 'WelcomeDefault'
        this.ready = true
      }
    }
    // if (this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']) {
    //   this.layout = `Welcome${this.$store.getters.sysConfigs['WELCOME_LAYOUT_NAME']}`
    //   this.ready = true
    // } else {
    //   this.layout = 'WelcomeDefault'
    //   this.ready = true
    // }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.welcome-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
